import React from 'react';
import CongestionSummary from './CongestionSummary';
import { useTranslation } from '@hooks';

const checkFalsyValue = value => {
    return value ? value : 0;
};

const SelectedCongestionSummary = ({ selectedCongestionInfo }) => {
    const t = useTranslation('CongestionStatus');
    return (
        <div className={'d-grid'} style={{ gridTemplateColumns: 'repeat(4,1fr)', gap: '8px' }}>
            <CongestionSummary
                count={checkFalsyValue(selectedCongestionInfo.entryCount)}
                totalCount={0}
                label={t('Total count of entries')}
            />
            <CongestionSummary
                count={checkFalsyValue(selectedCongestionInfo.uniqueCount)}
                totalCount={0}
                label={t('Unique count of entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(selectedCongestionInfo.avgStayEntryTime)}
                label={t('Average length of stay of total entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(selectedCongestionInfo.avgStayUniqueTime)}
                label={t('Average length of stay of unique entries')}
            />
        </div>
    );
};

export default SelectedCongestionSummary;
